export default __webpack_public_path__ + "static/media/sipmenu-pause.a9bd1f5d.svg";